export default "__VITE_ASSET__D9U5i$fh__"